import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ChartSection = ({
    title,
    renderChart,
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                width: '100%',
                ...sx,
            }}
            {...props}
        >
            <Typography
                sx={{
                    fontSize: '16px',
                    color: theme.palette.figma.white[80],
                    fontWeight: 500,
                    letterSpacing: '-0.48px',
                    textAlign: 'left',
                }}
            >
                {title}
            </Typography>
            {renderChart}
        </Box>
    );
};

export default ChartSection;
